import React, { useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StorefrontContext } from '../../../../../Context/StorefrontContext';
import { addAboutItemToLast, pushToVersions, setSectionFormType, updateVersionIndex } from '../../../../../Features/storefrontSlice';
import CrossGray from '../../../../../Assets/StorefrontIcons/CrossGray.svg';
import FeatureSection from './FeatureSection';
import imageCompression from 'browser-image-compression';
import { v4 as uuidv4 } from 'uuid';
import { getMediaUrl } from '../../../../../lib/utils/utils';

function FeaturesTwoForm() {
    const dispatch = useDispatch();

    const selectedFeatureTwoSection = useSelector((state) => state.storefront.selectedFeatureTwoSection);
    const versionStack = useSelector((state) => state.storefront.versionStack);
    const versionIndex = useSelector((state) => state.storefront.versionIndex);

    const {
        defaultFeaturesTwo,
        featuresTwo,
        setFeaturesTwo,
    } = useContext(StorefrontContext);

    function closeForm() {
        dispatch(setSectionFormType(null));
        // dispatch(setSelectedCarouselBannerSection('Banner 1'));
        setFeaturesTwo(defaultFeaturesTwo);
    }

    async function handleSave() {
        const currentVersion = versionStack[versionIndex];

        const newFeatureData = await Promise.all(featuresTwo
            .filter(feature => feature.image && (feature.image.file || feature.image.url))
            .map(async feature => {
                const object = {};

                object.altText = feature.altText || "";
                object.Heading = feature.heading || "";

                const image = feature.image.file;

                if (image) {
                    let url;
        
                    if (image.size > 1048576) {
                        try {
                            const compressedBlob = await imageCompression(image, { maxSizeMB: 1, maxWidthOrHeight: 1920, useWebWorker: true });
                            const compressedFile = new File([compressedBlob], image.name, { type: image.type, lastModified: Date.now() });

                            url = await getMediaUrl(compressedFile);
                        }
                        catch (err) {
                            console.warn('Image compression failed, using original file:', err);
                            url = await getMediaUrl(image);
                        }
                    }
                    else {
                        url = await getMediaUrl(image);
                    }
                    object.imageLink = url;
                }
                else {
                    object.imageLink = feature.image.url || "";
                }
        
                return { ...object };
            })
        )

        const tempAboutData = [ ...currentVersion.storeAbout ];

        const featureTwoDataIndex = tempAboutData.findIndex(
            item => item.item.TypeData === 'FEATURE2'
        );

        if (featureTwoDataIndex !== -1) {
            tempAboutData[featureTwoDataIndex] = {
                ...tempAboutData[featureTwoDataIndex],
                item: {
                    ...tempAboutData[featureTwoDataIndex].item,
                    featureItems: newFeatureData,
                }
            };

            const newIndex = versionStack[versionStack.length - 1].index + 1;

            const newVersion = {
                ...currentVersion,
                index: newIndex,
                storeAbout: tempAboutData,
                comment: 'Update Feature2 section',
            }

            dispatch(pushToVersions(newVersion));
            dispatch(updateVersionIndex(newIndex));
        }
        else {
            const object = {
                TypeData: 'FEATURE2',
                featureItems: newFeatureData,
            }

            dispatch(addAboutItemToLast(object));
        }
        closeForm();
    }

    function handleAddMore() {
        const listLength = featuresTwo.length;
        setFeaturesTwo([
            ...featuresTwo,
            {
                title: `Feature ${listLength + 1}`,
                image: {},
                altText: '',
                heading: '',
            }
        ]);
    }

    useEffect(() => {
        function fetchData() {
            const tempVersion = versionStack[versionIndex]?.storeAbout;

            if(tempVersion.length > 0) {
                const { item: featureTwoData = null } = tempVersion.find(item => item.item.TypeData === 'FEATURE2') || {};

                if(featureTwoData) {
                    if(featuresTwo.length <= featureTwoData.featureItems.length) {
                        let itemsToAdd = [];
                        for(let i = 0; i < featureTwoData.featureItems.length; i++) {
                            itemsToAdd.push({
                                title: `Feature ${i + 1}`,
                                image: {
                                    id: uuidv4(),
                                    url: featureTwoData.featureItems[i].imageLink,
                                    file: null,
                                },
                                altText: featureTwoData.featureItems[i].altText,
                                heading: featureTwoData.featureItems[i].Heading,
                            });
                        }

                        setFeaturesTwo(itemsToAdd);
                    }
                }
            }
        }

        fetchData();
        // eslint-disable-next-line
    }, [versionStack, versionIndex]);

    return (
        <div className='w-[305px] h-full bg-[#FFFFFF] border-l border-[#EAEAEA] flex flex-col gap-4 select-none relative'>
            <div className="flex items-center justify-between">
                <p className='font-semibold text-[20px] leading-6 text-[#121212] pl-3'>Features 2</p>

                <div className="size-11 p-[10px] flex items-center justify-center">
                    <button onClick={closeForm} className='size-6 flex items-center justify-center outline-none'>
                        <img src={CrossGray} alt="" />
                    </button>
                </div>
            </div>

            <div className="h-[calc(100%-44px)] flex flex-col overflow-y-scroll no-scrollbar pb-16">
                {
                    featuresTwo?.map((feature, index) => {
                        const isSelected = selectedFeatureTwoSection === feature.title;
                        const isFirst = index === 0;

                        return (
                            <FeatureSection 
                                key={feature.title} 
                                feature={feature} 
                                isSelected={isSelected} 
                                isFirst={isFirst} 
                            />
                        )
                    })
                }

                <button onClick={handleAddMore} className='outline-none p-3 font-semibold text-[14px] leading-4 text-[#1055EB] w-fit'>Add more</button>
            </div>

            <div className="absolute bottom-0 left-0 w-full p-3 bg-[#FFFFFF]">
                <button onClick={handleSave} className='w-full outline-none px-4 py-[6px] bg-primaryColor hover:bg-primaryAccent rounded-md font-semibold text-[12px] leading-6 text-buttonText'>Save changes</button>
            </div>
        </div>
    );
}

export default FeaturesTwoForm;
